import { router } from "routes/index";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "react-toastify/dist/ReactToastify.css";
import "react-phone-number-input/style.css";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ToastContainer
        position="bottom-center"
        toastClassName={
          "!ring-1 !ring-slate-900/10 !shadow-lg !rounded-lg !font-sans !min-h-fit"
        }
      />
    </QueryClientProvider>
  );
}

export default App;
